var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderNotConfirmed = function SvgOrderNotConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.125h-6.785l2.745-2.82C14.23 4.6 9.81 4.5 7.08 7.205a6.875 6.875 0 0 0 0 9.79c2.73 2.705 7.15 2.705 9.88 0 1.36-1.35 2.04-2.915 2.035-4.895H21c0 1.98-.88 4.55-2.64 6.295-3.51 3.475-9.21 3.475-12.72 0S2.105 9.285 5.615 5.81a8.978 8.978 0 0 1 12.65 0L21 3v7.125ZM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5Z",
    fill: "#000",
    fillOpacity: 0.87
  })));
};
export default SvgOrderNotConfirmed;